import request from '@/utils/request'


// 查询商品-评论记录列表
export function listGoodsComment(query) {
  return request({
    url: '/goods/goods/comment/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商品-评论记录分页
export function pageGoodsComment(query) {
  return request({
    url: '/goods/goods/comment/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商品-评论记录详细
export function getGoodsComment(data) {
  return request({
    url: '/goods/goods/comment/detail',
    method: 'get',
    params: data
  })
}

// 新增商品-评论记录
export function addGoodsComment(data) {
  return request({
    url: '/goods/goods/comment/add',
    method: 'post',
    data: data
  })
}

// 修改商品-评论记录
export function updateGoodsComment(data) {
  return request({
    url: '/goods/goods/comment/edit',
    method: 'post',
    data: data
  })
}

// 删除商品-评论记录
export function delGoodsComment(data) {
  return request({
    url: '/goods/goods/comment/delete',
    method: 'post',
    data: data
  })
}
